import React from "react"

export default function FieldStoryPoints_FormValueNotEmpty(props:any) {

    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                <div className="ui5-story-points s-24">{props.value}</div>
            </div>
            {props.children}
        </React.Fragment>
    )
}
